import { useCallback, useEffect } from 'react';

import { LoginProviderEnum } from '@enum/login-provider.enum';
import { useLazySsoQuery } from '@hook/auth/auth.hooks';
import { ErrorFormInterface } from '@interface/form/error-form.interface';
import { isExist, isString } from '@util/data/is-exist';

export const useSSOLogin = () => {
  const [sso, { data, error, isLoading }] = useLazySsoQuery();

  const handleLoginProvider = useCallback((provider: LoginProviderEnum) => () => void sso(provider).unwrap(), []);

  useEffect(() => void (isExist(data) && isString(data.data.url) && window.location.replace(data.data.url)), [data]);

  return {
    isLoading,
    error: error as ErrorFormInterface,
    handleLoginProvider,
  };
};
